// extracted by mini-css-extract-plugin
export default {"root":"IconCaretUp_root__yhqbk","active":"IconCaretUp_active__OJE0+"};